import React from 'react';

import classes from './Footer.module.css';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Texts from 'react-sdk/Texts';
import logo_ludicius from '../../../../../images/logo_ludicius.png'
import logo_port from '../../../../../images/logo_port.png'

const Footer = () => {

  function handleClick(e) {
    e.preventDefault()
    PopupsManager.open(POPUPS.MENTION_LEGALES)
  }

  return (
    <div className={classes.Footer}>
      <div className={classes.succubus}>
        <a href="#" onClick={handleClick}>{Texts.get("mentions-legales-link")}</a>
        <img className={classes.logoPort} src={logo_port} alt="" />
      </div>
      <div className={classes.succubus}>
        <img src={logo_ludicius} alt="" />
        <a href="#" onClick={handleClick}>{"Seriously made with fun by Ludicius Interactive"}</a>
      </div>
    </div>
  );
};

export default Footer;
